import * as React from 'react';
import { Args } from '../types/request-context'
import { Omit } from '../utils/types'

const { Provider, Consumer } = React.createContext<Args>({} as any);

export const withArgs = <Props extends Args>(Component: React.ComponentType<Props>): React.ComponentType<Omit<Props, Args>> => {
    return (props) => (
        <Consumer>{(args) => (
            <Component {...args} {...props} />
        )}</Consumer>

    );
}

export {
    Provider as ArgsProvider,
    Consumer as ArgsConsumer
};
